import { userAgent } from "next/server";
import React, { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const StateContext = createContext();

export const ContextProvider = ({ children }) => {

  const BACKEND_URL = process.env.REACT_APP_BASE_URL;
  const HIKAL_URL = process.env.REACT_APP_HIKAL_DYNAMIC_URL;
  const HIKALRE_URL = process.env.REACT_APP_HIKALRE_DYNAMIC_URL;
  const NINA_URL = process.env.REACT_APP_NINA_DYNAMIC_URL;
  const FINDESTATES_URL = process.env.REACT_APP_FINDESTATES_DYNAMIC_URL;
  const BELAL_URL = process.env.REACT_APP_BELAL_DYNAMIC_URL;
  const PROPERTY_URL = process.env.REACT_APP_PROPERTY_DYNAMIC_URL;
  const APOELEZZ_URL = process.env.REACT_APP_APOELEZZ_DYNAMIC_URL;
  const ASM_URL = process.env.REACT_APP_ASM_DYNAMIC_URL;
  const RICHMIND_URL = process.env.REACT_APP_RICHMIND_DYNAMIC_URL;
  const TAVIRA_URL = process.env.REACT_APP_TAVIRA_DYNAMIC_URL;

  //   const [currentMode, setCurrentMode] = useState("light");
  // const [activeMenu, setActiveMenu] = useState(true);
  const [allRoutes, setAllRoutes] = useState([]);
  const [langCode, setLangCode] = useState("en");
  const [fontFam, setFontFam] = useState("'Raleway', serif");

  // USER INFO
  const [userInfo, setUserInfo] = useState({
    ip: null,
    userAgent: null,
    countryCode: null,
    countryName: null,
    state: null,
  });

  // LANGUAGE
  const { t, i18n } = useTranslation();

  // AVAILABLE LANGS
  const langs = [
    {
      code: "en",
      name: "English",
      title: "English",
      rtl: false,
      flag: "/assets/images/flags/english-flag.png",
      font: "'Poppins', sans-serif",
      size: "12px",
    },
    {
      code: "ar",
      name: "Arabic",
      title: "عربي",
      rtl: true,
      flag: "/assets/images/flags/arabic-flag.png",
      font: "'Cairo', serif",
      size: "12px",
    },
    {
      code: "fa",
      name: "Farsi",
      title: "فارسی",
      rtl: true,
      flag: "/assets/images/flags/farsi-flag.png",
      font: "'DastNevis', sans-serif",
      size: "14px",
    },
    {
      code: "tr",
      name: "Turkish",
      title: "Türk",
      rtl: false,
      flag: "/assets/images/flags/turkey-flag.png",
      font: "'Raleway', serif",
      size: "12px",
    },
  ];

  // RETRIEVE LANGUAGE DETAILS
  const getLangDetails = (langCode) => {
    const language = langs.find((lang) => lang.code === langCode);
    if (language) {
      const { title, flag, font, size, rtl } = language;
      document.body.style.direction = rtl ? "rtl" : "ltr";
      document.body.style.setProperty("font-family", font);
      document.body.style.fontFamily = font;
      document.body.style.fontSize = size;
      setFontFam(font);
      return { title, flag };
    }
    return null;
  };

  // CHECK IF LANGUAGE IS RTL
  const isLangRTL = (langCode) => {
    const language = langs.find((lang) => lang.code === langCode);
    return language ? language.rtl : false;
  };

  // CHANGE LANGUAGE
  const changeLanguage = (newLangCode) => {
    setLangCode(newLangCode);
    i18n.changeLanguage(newLangCode);
    getLangDetails(newLangCode);
  };

  // CHECK URL PATH TO SET LANGUAGE
  useEffect(() => {
    const path = window.location.pathname;
    const langFromUrl = path.split("/")[1];
    if (langFromUrl === "ar") {
      changeLanguage("ar");
    } else {
      const langExists = langs.find((lang) => lang.code === langFromUrl);
      if (langExists) {
        changeLanguage(langFromUrl);
      } else {
        changeLanguage("en");
      }
    }
  }, []);

  // APPLY LANGUAGE DETAILS ON INITIAL LOAD
  useEffect(() => {
    getLangDetails(langCode);
  }, [langCode]);

  // CHECK IF TEXT CONTAINS ARABIC CHARACTER
  const isArabic = (text) => {
    const regex = new RegExp(
      "[\u0600-\u06FF\u0750-\u077F\u08a0-\u08ff\uFB50-\uFDFF\uFE70-\uFEFF]+([\u0600-\u06FF\u0750-\u077F\u08a0-\u08ff\uFB50-\uFDFF\uFE70-\uFEFF\\W\\d]+)*",
      "g"
    );
    if (text) {
      return text.match(regex);
    } else {
      return false;
    }
  };

  // CHECK IF TEXT CONTAINS ENGLISH CHARACTER
  const isEnglish = (text) => {
    const regex = new RegExp("^[\u0000-\u007F]+$", "g");
    if (text) {
      return text.match(regex);
    } else {
      return false;
    }
  };

  // FETCH USER INFO
  // useEffect(() => {
  //   const fetchUserInfo = async () => {
  //     try {
  //       // USER AGENT
  //       const userAgent = navigator.userAgent;
  //       // IP AND LOCATION
  //       const response = await fetch("https://ipapi.co/json/");
  //       const data = await response.json();

  //       setUserInfo({
  //         ip: data.ip,
  //         userAgent,
  //         countryCode: data.country_code,
  //         countryName: data.country_name,
  //         state: data.region,
  //       });
  //     } catch (error) {
  //       console.error("Error fetching user info:", error);
  //     }
  //   };
  //   fetchUserInfo();
  //   // console.log("USER INFO::: ", userInfo);
  // }, []);

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const res = await fetch("https://ipwho.is/");
        const data = await res.json();
        setUserInfo({
          ip: data.ip,
          userAgent: navigator.userAgent,
          countryCode: data.country_code,
          countryName: data.country,
          state: data.region,
        });
      } catch (err) {
        console.error("Error fetching user info:", err);
      }
    };
    fetchUserInfo();
  }, []);

  useEffect(() => {
    if (userInfo.ip && userInfo.countryName) {
      console.log("USER INFO::: ", userInfo);
    }
  }, [userInfo]);

  return (
    <StateContext.Provider
      value={{
        BACKEND_URL,
        HIKAL_URL,
        HIKALRE_URL,
        NINA_URL,
        FINDESTATES_URL,
        BELAL_URL,
        PROPERTY_URL,
        APOELEZZ_URL,
        ASM_URL,
        RICHMIND_URL,
        TAVIRA_URL,
        langs,
        langCode,
        setLangCode,
        allRoutes,
        setAllRoutes,
        isArabic,
        isEnglish,
        isLangRTL,
        getLangDetails,
        fontFam,
        setFontFam,
        t,
        i18n,
        changeLanguage,
        userInfo,
        // currentMode,
        // setCurrentMode,
        // activeMenu,
        // setActiveMenu,
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
